import {Grid, makeStyles, Typography, useMediaQuery} from '@material-ui/core';
import React, {useState} from 'react';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import {Benefit, BenefitDetail} from '../../models/Policy';
import BenefitAccordion from './BenefitAccordion';
import {DesktopDialog, FullScreenDialog} from './BenefitDialog';

const usePolicyBenefitsDetailStyles = makeStyles(_theme => ({
  header: {
    color: '#0D1941',
    width: '100%',
    fontSize: '1rem',
    fontWeight: 'bold',
    textAlign: 'left',
    marginBottom: '1rem',
  },
  benefitsContainer: {
    padding: '1.25rem 1.75rem',
  },
}));

export interface PlanBenefitProps {
  benefits: Benefit[];
}

const PlanBenefit = ({benefits}: PlanBenefitProps) => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const {benefitsContainer, header} = usePolicyBenefitsDetailStyles();

  const [open, setOpen] = useState(false);
  const [expandedAccordionIndex, setExpandedAccordionIndex] = useState(-1);
  const [selectedBenefitIndex, setSelectedBenefitIndex] = useState(-1);

  const handleBenefitClick = (index: number) => {
    setSelectedBenefitIndex(index);
    if (!open) {
      setOpen(true);
    }
  };

  const handleAccordionClick = (index: number) => {
    setExpandedAccordionIndex(index === expandedAccordionIndex ? -1 : index);
    setSelectedBenefitIndex(-1);
  };

  const selectedBenefitDetail: BenefitDetail[] =
    expandedAccordionIndex >= 0 ? benefits[expandedAccordionIndex].details : [];

  return (
    <div className={benefitsContainer}>
      <Typography variant="h3" className={header}>
        Your Benefit Details
      </Typography>
      <Grid container direction="column" spacing={2}>
        {benefits.map((benefit, index) => (
          <BenefitAccordion
            benefit={benefit}
            handleBenefitClick={handleBenefitClick}
            idx={index}
            handleAccordionClick={handleAccordionClick}
            active={expandedAccordionIndex === index}
            key={toKebabCase(benefit.desc)}
          />
        ))}
      </Grid>

      {expandedAccordionIndex >= 0 && selectedBenefitIndex >= 0 && (
        <>
          {isMobile ? (
            <FullScreenDialog
              onClose={() => setOpen(false)}
              open={open}
              selectedBenefitDetail={selectedBenefitDetail}
              selectedBenefitIndex={selectedBenefitIndex}
              handleBenefitClick={handleBenefitClick}
            />
          ) : (
            <DesktopDialog
              open={open}
              handleClose={() => setOpen(false)}
              benefitToRender={selectedBenefitDetail[selectedBenefitIndex]}
            />
          )}
        </>
      )}
    </div>
  );
};

export default PlanBenefit;
